import { arrayOf, Schema } from 'normalizr';


const BANNER_SCHEMA = new Schema('banners');

export const BANNERS_SCHEMA = arrayOf(BANNER_SCHEMA);
